import { classificationClass } from "@/lib/format";

export function ClassificationBadge({ classification, className = "", testId }) {
  if (!classification) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider border ${classificationClass(classification)} ${className}`}
      data-testid={testId || `classification-${classification.toLowerCase()}`}
    >
      {classification}
    </span>
  );
}
